/*
 * @Author: cn1994
 * @Date: 2023-01-17 10:49:17
 * @LastEditors: cn1994
 * @LastEditTime: 2024-01-26 15:50:33
 * @Description: 登陆相关页面
 */

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登陆'
    },
    component: () => import('../pages/login/index.vue'),
  },
]

export default routes
